/* eslint-disable max-len */
import React from 'react';
import { LayoutContext } from './layout-context';

export function withLayoutContext<P>(Component: React.ComponentType<P>) {
  function WrappedComponent<K>(props: K) {
    return (
      <LayoutContext.Consumer>
        {({ config, change, isGridLayout }) => (
          <Component {...(props as any as P)} changeLayout={change} layoutConfig={config} isGridLayout={isGridLayout} />
        )}
      </LayoutContext.Consumer>
    );
  }

  return WrappedComponent;
}
